import * as angular from 'angular';
import CoreModule from './core/core.module';
import SharedModule from './shared/shared.module';
import FourOFourModule from './four-o-four/four-o-four.module';
import LoginModule from './login/login.module';
import HomeModule from './home/home.module';
import ProductModule from './product/product.module';
import CommunicationToolModule from './communication-tool/communication-tool.module';
import GeographyModule from './geography/geography.module';
import appComponent from './app.component';

export default angular
  .module('FHL', [
    CoreModule,
    SharedModule,
    FourOFourModule,
    LoginModule,
    HomeModule,
    ProductModule,
    CommunicationToolModule,
    GeographyModule,
  ])
  .constant('FENDI_CONSTANT', window.fendi)
  .component('app', appComponent)
  /* @ngInject */
  .config(($compileProvider, RouterServiceProvider, HttpServiceProvider, $translateProvider, $qProvider) => {
    RouterServiceProvider.configureOtherwisePath('/404');
    RouterServiceProvider.html5Mode(true);
    HttpServiceProvider.BASE_PATH = window.__FHL__.host.base;
    HttpServiceProvider.addInterceptor('httpInterceptor');
    HttpServiceProvider.addInterceptor('cacheInterceptor');
    $compileProvider.debugInfoEnabled(false);
    $translateProvider
      .useStaticFilesLoader({prefix: 'assets/i18n/', suffix: '.json'})
      .preferredLanguage('en')
      .fallbackLanguage('en')
      .useSanitizeValueStrategy(null); // prima era 'escape' ma rompeva caratteri speciali tipo '&'
    // $qProvider.errorOnUnhandledRejections(false);
  })
  /* @ngInject */
  .run((RouterService, AuthService, LocalStorageService) => {
    let storeLocationSearch;
    const persistParams = ['product', 'productRelated', 'productCheck'];

    RouterService.onBefore({to: state => state.name !== 'login'}, (transitions) => {
      const isAuth = !!AuthService.token();
      if (!isAuth) {
        const {href, pathname} = window.location;
        RouterService.state.go('login');
        pathname.includes('404') ? null : LocalStorageService.set('redirectPostLogin', href);
        throw new Error('Must be logged');
      }
      // if (transitions.$to().name === 'productCheck' && AuthService.isPersonalShopper()) {
      //   RouterService.state.go('home');
      //   throw new Error('Must be administrator');
      // }
      return isAuth;
    });

    RouterService.onStart({to: state => persistParams.includes(state.name)}, () => {
      storeLocationSearch = RouterService.location.search();
    });

    RouterService.onSuccess({to: state => persistParams.includes(state.name)}, () => {
      RouterService.location.search(storeLocationSearch);
    });
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/app.module.js